<template>
    <div id="history" v-show = "data.show">
        <div class="mask"></div>
        <div class="history_box">
            <div class="history_title">
                <label>历史记录</label>
                <a href="javascript:;" class="close_h" @click="hide">×</a>
            </div>
            <div class="history_content">
                
                <div class="h_left">
                    <div  v-if="data.text_answer.length > 0">
                    
                    <a href="javascript:;" 
                        v-for="(item,index) in data.text_answer"
                        :key="index"
                        :class="{'check':index == cur}" 
                        data-index="0"
                        @click="cur = index"
                    >{{ item.time }}</a>
                </div>
                    
                </div>
                <div class="h_right">
                    <div v-if="data.text_answer.length > 0"  v-html="data.text_answer[cur].answer"></div>

                </div>

            </div>
            <div class="history_btn">
                <a href="javascript:;" class="restore" @click="restore">恢复</a>
                <a href="javascript:;" class="cancel"  @click="hide">取消</a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:"history",
    data(){
        return{
            cur:0
            

        }
    },
    props:["data"],
    watch:{
        data:{
            immediate:true,
            handler(val){
                this.cur = val.text_answer.length - 1
            },
            deep:true
        }
    },
    created(){
        
    },
    methods:{
        //隐藏
        hide(){
            this.data.show = false
        },
        //恢复
        restore(){
            
            this.$emit("restore",this.data.text_answer[this.cur].answer);
            this.hide();
        }

    }
}
</script>
<style lang="scss" scoped>
#history{position: relative;    z-index: 999999999;}
.mask {    position: fixed;    left: 0;    top: 0;    right: 0;    bottom: 0;}
.history_box{    position: fixed;    width: 1000px;    height: 90%;    top: 5%;    left: 50%;    margin-left: -500px;    background: #f1f1f1;    box-shadow: 0 0 2px #ccc;}
.history_title{    background: #000;    color: #fff;    padding: 10px;}
.close_h{    float: right;    background: red;    color: #fff;    width: 20px;    text-align: center;    height: 20px;    line-height: 20px;}
.history_content{    position: absolute;    top: 41px;    bottom: 40px;    left: 0;    right: 0;}
.history_content .h_left{    float: left;    width: 200px;	height: 100%;	overflow-y:auto;    border-right: 1px solid #dcdcdc;}
.h_left a{    padding: 10px 5px;    display: block;}
.h_left .check{background:#1d7ecc;color:#fff}
.history_content .h_right{ overflow-y: auto;   margin-left: 200px;    height: 100%;    padding: 10px;    box-sizing: border-box;}
.history_btn{    position: absolute;    bottom: 0;    height: 40px;    text-align: center;    width: 100%;    border-top: 1px solid #dcdcdc;}
.history_btn a{    display: inline-block;    background: #1d7ecc;    color: #fff;    width: 100px;    height: 30px;    line-height: 30px;    border-radius: 4px;    margin: 5px 49px;}

</style>